// extracted by mini-css-extract-plugin
module.exports = {"cards":"List_cards__1s13G","wrapper":"List_wrapper__12lop"};